var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToggleAscDesactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 19,
    viewBox: "0 0 23 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#a1a1a1;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13747 -3743)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.335,156.407H7.816v13.786h-2.8l4.558,5.214,4.559-5.214h-2.8Z",
    transform: "translate(13761.134 3918.407) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 11.98,
    height: 3.056,
    transform: "translate(13758.021 3745.792)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 9.537,
    height: 3.056,
    transform: "translate(13758.021 3750.856)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 7.386,
    height: 3.056,
    transform: "translate(13758.158 3755.923)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleAscDesactive);
export default __webpack_public_path__ + "static/media/toggle-asc-desactive.212f3a30aa58ac804a3323b5254e2964.svg";
export { ForwardRef as ReactComponent };